import React, { useState } from 'react'
import './find.css'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'

import { locations, industries } from '../../../../data'
import { jobOptions } from '../../../../data'
import building from '../../../../images/building.svg'
import location from '../../../../images/location.svg'
import clock from '../../../../images/clock.svg'
import bag from '../../../../images/bag.svg'
import bullet from '../../../../images/bullet.svg'
import Menu from './menu'
import { Container, Col, Row, Form, Button} from 'react-bootstrap';

const FindJobs = () => {
  const [jobs,setJobs] = useState(jobOptions)
  const [selectedJob, setSelectedJob] = useState(jobOptions[1])
  const [selectedIndustry, setSelectedIndustry] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedCheckbox1, setSelectedCheckbox1] = useState("");
  const [selectedJobType, setSelectedJobType]= useState('')
  const [selectedWorkMode, setSelectedWorkMode]= useState('')
  const [selectedCheckbox2, setSelectedCheckbox2] = useState("");
  const [searchText,setsearchText] = useState('');

  const handleIndustryChange = (event) => {
    setSelectedIndustry(event.target.value);
   
  };

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
    
  };
  
  const handleCheckboxChange1 = (event) => {
     setSelectedJobType(event.target.name)
    setSelectedCheckbox1(event.target.value);
  };
  const handleCheckboxChange2 = (event) => {
    setSelectedWorkMode(event.target.name)
    setSelectedCheckbox2(event.target.value);
  };

  const handleSearch= (e) => {
    e.preventDefault();
    const gotText = searchText.toLowerCase();
    
    let newList=[...jobOptions]
    if(gotText){
      newList= newList.filter(jobOption=>
         jobOption.role.toLowerCase().includes(gotText)
      )
    }
    if(selectedJobType){
      newList= newList.filter(jobOption=>
        jobOption.jobType.toLowerCase() === selectedJobType.toLowerCase()
      )
    }
    if(selectedWorkMode){
      newList= newList.filter(jobOption=>
        jobOption.workMode.toLowerCase() === selectedWorkMode.toLowerCase()
      )
    }
    if(selectedIndustry){
      newList= newList.filter(jobOption=>
        jobOption.industries.toLowerCase() === selectedIndustry.toLowerCase()
      )
    }
    if(selectedLocation){
      newList= newList.filter(jobOption=>
        jobOption.location.toLowerCase()=== selectedLocation.toLowerCase()
      )
    }
    setJobs(newList)

   
  }

  return (
    <div>
      <ProfileNavbar/>
      <Container fluid className='p-4 ' style={{background: 'rgba(255, 161, 94, 0.55)'}}>
          <Form  className='py-3 px-4' style={{background: 'rgba(53, 44, 44, 0.8)',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>
            <Row>
              <Col>
                <div className='d-block d-sm-flex gap-2 '>
                <Form.Control className='align-items-center justify-content-center text-center p-2 mb-2 mb-sm-0' type='text'  value={searchText} placeholder='Search for jobs' onChange={(e) => {setsearchText(e.target.value)
              if(e.target.value === ''){
                setJobs(jobOptions)
              }}}/>
               <Form.Select className='align-items-center justify-content-center text-center p-2 mb-2 mb-sm-0'  value={selectedIndustry}
                onChange={handleIndustryChange}>
               <option>Industries</option>
               {industries.map((industry) => (
               <option key={industry} value={industry}>
                {industry}
               </option>
                ))}
                </Form.Select>
                <Form.Select className='align-items-center justify-content-center text-center p-2 mb-2 mb-sm-0'  value={selectedLocation}
          onChange={handleLocationChange}>
               <option>Locations</option>
               
               {locations.map((location) => (
            <option key={location} value={location}>
              {location}
            </option>
            ))}
                </Form.Select>
                </div>
                <div className='d-block d-xl-flex mt-3 gap-5' style={{background:'#fff'}}>
          <div className='d-block d-sm-flex align-items-center py-2 px-4 check-field'>
            <p>JOB TYPE : </p>
            <div class="checkbox-group d-block d-sm-flex  align-items-center">
            <Form.Group className=" d-flex align-items-center" controlId="formBasicCheckbox">
              <Form.Label className=" d-flex align-items-center mt-2" >Full-Time
              <Form.Check className='mb-2'type="checkbox" name='full-time' value="checkbox1" checked={selectedCheckbox1 === "checkbox1"} onChange={handleCheckboxChange1}/>
              </Form.Label>
            
            </Form.Group>
            <Form.Group className=" d-flex align-items-center" controlId="formBasicCheckbox">
              <Form.Label className=" d-flex align-items-center mt-2" > Part-Time 
              <Form.Check className='mb-2' type="checkbox" name='part-time' value="checkbox2" checked={selectedCheckbox1 === "checkbox2"} onChange={handleCheckboxChange1}/>
              </Form.Label>
            
            </Form.Group>
              
             
            </div>
          </div>
          <div className='d-block d-sm-flex align-items-center py-2 px-4 check-field'>
            <p>WORK MODE : </p>
            <div class="checkbox-group d-block d-sm-flex  align-items-center">
            <Form.Group className=" d-flex align-items-center" controlId="formBasicCheckbox">
              <Form.Label className=" d-flex align-items-center mt-2" >Remote
              <Form.Check className='mb-2' type="checkbox" name='remote' value="checkbox1" checked={selectedCheckbox2 === "checkbox1"} onChange={handleCheckboxChange2}/>
              </Form.Label>
            
            </Form.Group>
            <Form.Group className=" d-flex align-items-center" controlId="formBasicCheckbox">
              <Form.Label className=" d-flex align-items-center mt-2" > Hybrid
              <Form.Check className='mb-2' type="checkbox" name='hybrid' value="checkbox2" checked={selectedCheckbox2 === "checkbox2"} onChange={handleCheckboxChange2}/>
              </Form.Label>
            
            </Form.Group>
             <Form.Group className=" d-flex align-items-center" controlId="formBasicCheckbox">
              <Form.Label className=" d-flex align-items-center mt-2" > Monday - Friday
              <Form.Check className='mb-2' type="checkbox" name='monday-friday' value="checkbox3" checked={selectedCheckbox2 === "checkbox3"} onChange={handleCheckboxChange2}/>
              </Form.Label>
            
            </Form.Group>
              
             
            </div>
          </div>
         
          
         
           </div>
              </Col>
              <Col lg={3} className='d-flex align-items-center justify-content-center text-center mt-3 mt-lg-0'>
              <button className='filter-search-btn' onClick={handleSearch}>Search</button>
              </Col>
            </Row>
           
          </Form>
          <Menu jobs ={jobs}/>
      </Container>
     
    </div>
  )
}

export default FindJobs
